// extracted by mini-css-extract-plugin
module.exports = {"flash-sale-cards":"Cards_flash-sale-cards__SUT8x"};